<template>
  <div>
    <div class="card mb-3" v-for="(item,index) in data" :key="index">
      <div class="card-header" @click="toggle(index)">
        <h5>{{item.header}}</h5>
      </div>
      <div class="card-body" :class="[active==index ? 'show' : 'hide']">
        <p class="card-text">{{item.content}}</p>
      </div>
    </div>
  </div>
</template>

<style media="screen">
  .show {
    display: block;
  }

  .hide {
    display: none;
  }
  h5{
    text-transform: none
  }
</style>

<script type="text/javascript">
  export default {
    name: 'Accordian',
    props: {
      data: Array
    },
    data: function() {
      return {
        active: null
      }
    },
    methods: {
      toggle: function(index){
        if(this.active==index)
          this.active = null
        else
          this.active = index
      }
    }
  }
</script>
